import httpClient from '@/api/http-client';

const endpoint = 'api/permit-issues';

const permitIssuesService = {
  create: (issue) => httpClient.post(`${endpoint}`, issue),

  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),
};

export default permitIssuesService;
